import type { SVGProps } from "react"

type ISvgProps = SVGProps<SVGSVGElement>

export function Delete(props: ISvgProps) {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M39.5 11L38.2605 31.0502C37.9439 36.1729 37.7855 38.7343 36.5015 40.5757C35.8667 41.4862 35.0493 42.2546 34.1014 42.832C32.1842 44 29.618 44 24.4855 44C19.3462 44 16.7766 44 14.8581 42.8299C13.9096 42.2513 13.092 41.4816 12.4574 40.5697C11.1738 38.7252 11.0189 36.1602 10.7092 31.0303L9.5 11"
        stroke="#DB2777"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M6.5 11H42.5M32.6115 11L31.2461 8.18345C30.3391 6.31251 29.8857 5.37704 29.1034 4.79361C28.9299 4.6642 28.7462 4.54908 28.554 4.4494C27.6878 4 26.6482 4 24.5691 4C22.4377 4 21.372 4 20.4914 4.46824C20.2962 4.57202 20.11 4.69179 19.9346 4.82634C19.1433 5.4334 18.7013 6.40311 17.8172 8.34251L16.6058 11"
        stroke="#DB2777"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path d="M19.5 33L19.5 21" stroke="#DB2777" stroke-width="1.5" stroke-linecap="round" />
      <path d="M29.5 33L29.5 21" stroke="#DB2777" stroke-width="1.5" stroke-linecap="round" />
    </svg>
  )
}
